import React, { Component, Fragment } from "react";
import { Button, Badge, Hidden, withWidth } from "@material-ui/core";
import FoodDetails from "./FoodDetails";

const fullScreenValid = ["xs", "sm"];

class FeedbackIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {}
    };
    this.changeListener(props);
  }

  componentWillReceiveProps(nextProps) {
    this.changeListener(nextProps);
  }

  changeListener = props => {
    const { feedbackState } = props;

    if (feedbackState) {
      this.listener("add");
    } else {
      this.listener("remove");
    }
  };

  listener = eventFunc => {
    // Create IE + others compatible event handler
    var eventMethod;
    var messageEvent;
    if (eventFunc === "add") {
      eventMethod = window.addEventListener
        ? "addEventListener"
        : "attachEvent";
      messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    } else {
      eventMethod = window.removeEventListener
        ? "removeEventListener"
        : "detachEvent";
      messageEvent = eventMethod == "detachEvent" ? "onmessage" : "message";
    }
    var eventer = window[eventMethod];

    // Listen to message from child window
    eventer(messageEvent, this.closeFeedbackDialog, false);
  };

  closeFeedbackDialog = event => {
    if (
      event.origin === window.location.origin &&
      event.data === "foodbook-feedback-close-event"
    ) {
      this.props.toggleFeedback(false);
    }
  };

  render() {
    const { classes, width, feedbackState, formData } = this.props;
    let fullScreen = false;
    if (fullScreenValid.includes(width)) {
      fullScreen = true;
    }

    return (
      <FoodDetails
        postFix=""
        lwMode={true}
        fullScreen={fullScreen}
        details={formData}
        open={feedbackState}
        handleClose={() => this.props.toggleFeedback(false)}
      />
    );
  }
}

export default withWidth()(FeedbackIframe);



// WEBPACK FOOTER //
// ./src/components/Dashboard/FeedbackIframe.js